import React, { FC, Fragment, useState } from 'react';
import { ArrowLeftIcon, ClockIcon } from 'cokitchen-icons';
import { IssueType } from 'models/issue.model';
import { getOrderStatus, getSimpleDateFormat } from 'utils/functions';
import OrderDetail from 'pages/order-details';
import OrderStatus from 'components/base/order-status';
import IssueCardHeader from './issue-card-header';
import { BaseModal } from '@cokitchen/cokitchen-components';

type Props = {
  issue: IssueType;
  markIssue?: () => void;
  isComplete?: boolean;
  openReview?: () => void;
  setShowEscalateModal?: (item: boolean) => void;
  handleMenuClick?: () => void;
};

const RepIssueCard: FC<Props> = ({
  issue,
  markIssue,
  isComplete,
  openReview,
  setShowEscalateModal,
  handleMenuClick
}) => {
  const dateObj = new Date(issue.created_at);
  const time = dateObj.toLocaleString('en-NG', {
    hour: '2-digit',
    minute: '2-digit'
  });
  const order_code = issue.order_code?.toLowerCase();
  const [showDetails, setShowDetails] = useState(false);
  const closeOrderModal = () => {
    setShowDetails(false);
  };

  console.log(issue, order_code);

  return (
    <Fragment>
      <div
        onClick={() => openReview?.()}
        className='border hover:bg-[#e2e3e347] border-gray-border rounded-lg flex flex-col px-3'>
        <IssueCardHeader
          handleMenuClick={() => handleMenuClick?.()}
          issue={issue}
          markIssue={() => markIssue?.()}
          setShowDetails={setShowDetails}
          isComplete={isComplete}
          openReview={() => openReview?.()}
          setShowEscalateModal={() => setShowEscalateModal?.(true)}
        />
        <div className='border-t border-gray-border py-3 flex justify-between items-center'>
          <p className='flex text-gray-5 font-medium uppercase min-w-fit items-center gap-2 text-xs hover:underline tracking-wider'>
            {issue?.feedback_destination}
          </p>
          <div className='flex items-center gap-2 p-1 px-3 rounded-[2px] bg-[#F5F5F5] border border-[#EFEEEC] text-gray-5 text-xs'>
            <ClockIcon className='w-[14px] h-[14px] text-gray-5' />
            <div className='flex items-center gap-2'>
              {getSimpleDateFormat(issue?.created_at)}
              <div className='bg-[#BFBFBF] w-[6px] h-[6px] rounded-full' />
              {time}
            </div>
          </div>
        </div>
      </div>
      {showDetails && order_code && (
        <BaseModal
          position='right'
          isOpen
          onRequestClose={closeOrderModal}
          size='wide'
          title={
            <div className='flex flex-wrap lg:flex-nowrap gap-2 items-center'>
              <button onClick={closeOrderModal}>
                <ArrowLeftIcon className='w-6 h-6' />
              </button>
              <div className='font-semibold text-2xl'>Order #{order_code?.toUpperCase()}</div>

              {issue.order && (
                <div className='basis-full lg:basis-auto'>
                  <OrderStatus type={getOrderStatus(issue.order)} />
                </div>
              )}
            </div>
          }>
          <OrderDetail orderCode={order_code} />
        </BaseModal>
      )}
    </Fragment>
  );
};

export default RepIssueCard;
